<template>
	<div id="app-modals" class="AppModals"></div>
</template>